// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c1cbebc2","513":"8d130a27","703":"051550e0","787":"0f767122"}[chunkId] + ".chunk.js";
};